import { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import type { Props as TierPromotionCardSemiDumbProps } from '../TierPromotionCardSemiDumb';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';

export function useTierPromotionCardCtaType(
  deviation: PapiDeviation
): TierPromotionCardSemiDumbProps['ctaButton'] {
  const { isUserSubscribed, isOwner } = useSubscriptionTier(deviation);
  const isMobile = useContext(MobileContext);

  if (isOwner) {
    if (isMobile) {
      return;
    }

    return 'edit';
  }

  if (isUserSubscribed) {
    return 'view-subscribed';
  }

  if (!deviation.tier?.canUserSubscribe) {
    return 'disabled';
  }

  return 'subscribe';
}
